import React from "react";
import PatternOverlay from "@/components/PatternOverlay";

const SHIPPING = [
  { region: "United Kingdom", time: "2–3 working days", cost: "£5.95 · Free over £50" },
  { region: "Europe", time: "5–7 working days", cost: "£14 · Free over £120" },
  { region: "United States & Canada", time: "7–10 working days", cost: "£22 · Free over £180" },
  { region: "Rest of world", time: "10–14 working days", cost: "£28 · Free over £220" },
];

export default function ShippingReturnsPage() {
  return (
    <div className="pattern-bg w-full" data-testid="shipping-returns-page">
      <PatternOverlay opacity={0.09} size={520} />
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="text-xs uppercase tracking-[0.32em] text-primary">The details</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-4 tracking-tight leading-[1.02]">
          Shipping &amp; <span className="italic text-primary">Returns</span>.
        </h1>

        <section className="mt-14">
          <h2 className="font-serif text-3xl">Shipping</h2>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            Every æxènts order is dispatched from our London atelier within one
            working day, hand-packed in signature copper &amp; noir. All
            shipments are fully tracked and require a signature on delivery.
          </p>
          <div className="mt-8 border border-border divide-y divide-border" data-testid="shipping-table">
            {SHIPPING.map((row) => (
              <div key={row.region} className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-4 p-5">
                <div className="text-xs uppercase tracking-[0.24em] text-primary">{row.region}</div>
                <div className="text-sm text-muted-foreground">{row.time}</div>
                <div className="text-sm">{row.cost}</div>
              </div>
            ))}
          </div>
          <p className="mt-6 text-xs uppercase tracking-[0.22em] text-muted-foreground">
            Import duties &amp; taxes may apply outside the UK — payable on delivery.
          </p>
        </section>

        <section className="mt-16">
          <h2 className="font-serif text-3xl">Returns</h2>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            We accept returns on unopened, unused fragrances within{" "}
            <span className="text-primary">30 days</span> of delivery. For
            hygiene reasons we're unable to accept returns on opened bottles or
            sample sets that have been used.
          </p>
          <ol className="mt-6 space-y-4 text-sm text-muted-foreground list-decimal list-inside">
            <li>Email <span className="text-primary">care@aexents.com</span> quoting your order number.</li>
            <li>We'll issue a prepaid return label within one working day (UK) or return instructions (international).</li>
            <li>Once received &amp; checked, refunds are processed to the original payment method within 5 working days.</li>
          </ol>
        </section>

        <section className="mt-16">
          <h2 className="font-serif text-3xl">Damaged or faulty</h2>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            If something arrives less than perfect, please email{" "}
            <span className="text-primary">care@aexents.com</span> within 7 days
            of delivery with photographs. We'll arrange an immediate replacement
            or full refund — whichever you prefer.
          </p>
        </section>

        <section className="mt-16">
          <h2 className="font-serif text-3xl">Gift orders</h2>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            Every order arrives gift-ready in our signature packaging. To
            include a hand-written note, simply add your message at checkout.
          </p>
        </section>
      </div>
    </div>
  );
}
